// ===== if data not come from api show - sign
export const displayValue = (value: any) => {
  return value == null || value === "" ? "-" : value;
};

export const formatDate = (date: string | null | undefined) => {
  if (!date) return "-";

  const d = new Date(date);

  if (isNaN(d.getTime())) return "-";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};
